<template>
  <div class="core">
    <div class="layui-fluid">
      <pub-search :search-type="'add'" :tableObj="tableObj" :searchConfig="searchConfig" exportTemplate="返单表.xlsx">
        <template>
          <layui-exportexcel template-name="返单表.xlsx" ref="export">
            <template slot-scope="{ scope }">
              <button class="layui-btn layuiadmin-btn-role" @click="scope.export(tableObj)">
                <i class="layui-icon">&#xe67d;</i>导出
              </button>
            </template>
          </layui-exportexcel>
        </template>
      </pub-search>
      <template>
        <layui-table
          ref="backOrder"
          table-name="YW_SERVICE_ORDER"
          view-name="YW_SERVICE_ORDER_V1"
          :renderRow="renderRow"
          :page-size="20"
          :page-range="6"
          :page-options="[10, 20, 50, 100]"
          :skin="'line'"
          :defaultCondition="{ 'BACK_ORDER_TIME:9': '', 'AFRESH_DISPATCH_ID:8': '', 'SERVICE_DELETED:10': '1' }"
          :sort="['BACK_ORDER_TIME:DESC']"
          @table-event-cxpd="addOrder($event, 'cxpd')"
          @table-event-sp="addOrder($event, 'sp')"
          @table-event-detail="addOrder($event, 'ck')"
          @table-event-close="close($event)"
        >
          <div>
            <div checkbox="true" align="center" fixed="left" width="60"></div>
            <layui-tableconfig :config="tableList"></layui-tableconfig>
            <div rowspan="3" align="center" fixed="right" title="操作" width="115">
              <script type="text/html" v-pre>
                <i class="layui-icon t_check_a operate_table" lay-event="detail" title="查看"></i>
                {{# if(!d.AFRESH_DISPATCH_ID && d.ORDER_STATE !=='6' && d._mark.indexOf("backOrder_cxpd") > -1){ }}
                <i class="layui-icon t_pd_a operate_table" lay-event="cxpd" title="派单"></i>

                {{# } }} {{# if(d.REVIEW_TYPE === '1' && d.ORDER_STATE !=='6'){ }}
                <i class="layui-icon t_close_a operate_table" lay-event="close" title="关闭"></i>


                {{# } }} {{# if(d._mark.indexOf("backOrder_sp") > -1 && d.ORDER_STATE !=='6'){ }}
                <i class="layui-icon t_sp_a operate_table" lay-event="sp" title="审批"></i>
                {{# } }}
              </script>
            </div>
          </div>
        </layui-table>
      </template>
    </div>
    <back-order-form
      v-if="backOrderShow"
      :visible.sync="backOrderShow"
      :formData="formData"
      :operateType="operateType"
    />
  </div>
</template>
<script>
import '../../../utils/map/css/core.css'
import backOrderForm from './backOrderform'
import request from "@/network/networkconfig";
export default {
  name: 'backOrder',
  components: {
    backOrderForm,
  },
  data() {
    return {
      tableList: [
        { field: 'REVIEW_TYPE_DESC', title: '审核状态', width: 90 },
        { field: 'AFRESH_DISPATCH_ID_DESC', title: '是否重新派单', width: 120 },
        { field: 'ORDER_STATE_DESC', title: '服务请求单状态', width: 150, sort: true },
        { field: 'SERVICE_STATE_DESC', title: '现场服务单状态', width: 150, sort: true },
        { field: 'WORK_ORDER_NUM', title: '服务请求单编号', width: 150 },
        { field: 'WORK_ORDER_CATEGORY_DESC', title: '服务请求单类别', width: 130 },
        { field: 'SERVICE_ORDER_NUM', title: '现场服务单编号', width: 150 },
        { field: 'CLIENT_NAME', title: '客户', width: 200 },
        { field: 'BRAND_NAME', title: '品牌', width: 200 },
        { field: 'STORE_NAME', title: '门店', width: 130 },
        { field: 'ENGINEER_ID_DESC', title: '返单人员', width: 90 },
        { field: 'BACK_ORDER_TYPE_DESC', title: '返单类型', width: 130 },
        { field: 'BACK_ORDER_REASON', title: '返单原因', width: 200 },
        { field: 'BACK_ORDER_TIME', title: '返单时间', width: 180 },
        { field: 'REVIEW_USERID', title: '审核人', width: 130 },
        { field: 'REVIEW_TIME', title: '审核时间', width: 180 },
      ],
      searchConfig: {
        basic: [
          {
            TYPE: 'input',
            WIDTH: 260,
            FIELD: 'WORK_ORDER_NUM:2,SERVICE_ORDER_NUM:2,CLIENT_NAME:2,BRAND_NAME:2,STORE_NAME:2,BACK_ORDER_REASON:2',
            PLACEHOLDER: '请输入查询条件',
          },
        ],
        advanced: [
          { TYPE: 'input', NAME: '现场服务单编号 :', FIELD: 'SERVICE_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '服务请求单编号 :', FIELD: 'WORK_ORDER_NUM:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '客户 :', FIELD: 'CLIENT_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '品牌 :', FIELD: 'BRAND_NAME:2', PLACEHOLDER: '请输入查询条件' },
          {
            TYPE: 'select',
            NAME: '审核状态 :',
            FIELD: 'REVIEW_TYPE:0',
            tableName: 'DB_DICTIONARY',
            textField: 'DIC_NAME',
            valueField: 'DIC_CODE',
            queryCondition: { 'DIC_CATEGORY:0': '审核结果', 'DIC_PCODE:3': '-1' },
          },
          { TYPE: 'input', NAME: '门店 :', FIELD: 'STORE_NAME:2', PLACEHOLDER: '请输入查询条件' },
          { TYPE: 'input', NAME: '返单原因 :', FIELD: 'BACK_ORDER_REASON:2', PLACEHOLDER: '请输入查询条件' },
          {
            TYPE: 'layui-multiselect',
            NAME: '返单类型:',
            FIELD: 'BACK_ORDER_TYPE:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('BACK_ORDER_TYPE'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '服务请求单类别:',
            FIELD: 'WORK_ORDER_CATEGORY:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('WORK_ORDER_CATEGORY'),
          },
          {
            TYPE: 'layui-multiselect',
            NAME: '是否重新派单:',
            FIELD: 'B_BACK_ORDER:1',
            textField: 'text',
            valueField: 'value',
            initData: this.dict.getData('B_BACK_ORDER'),
          },
        ],
      },
      backOrderShow: false,
      formData: {},
      tableObj: {
        checkedRows: 0,
        queryObject: {},
      },
      operateType: '',
    }
  },
  mounted() {
    this.tableObj = this.$refs.backOrder
    //监听派单保存成功后刷新
    this.$bus.$on('dispatchForm', () => {
      this.dispatchForm = true
    })
  },
  activated() {
    if (this.dispatchForm) {
      this.dispatchForm = false
      this.tableObj.load()
    }
  },
  methods: {
    close(data, type) {
      this.layer.openConfirm('确定要关闭吗？', () => {
        request({
          url: '/yw/workOrder/closeBackOrderByWorkOrderId/' + data.data.WORK_ORDER_ID,
          method: 'post',
        }).then((result) => {
            if (result.result && result.result.errorMsg) {
              this.layer.openAlert(result.result.errorMsg)
            } else {
              this.layer.openSuccess('关闭成功!')
              this.tableObj.load();
            }
          },
          null,
          { targetEl: $('body') }
        )
      })
    },

    addOrder(params, type) {
      if (type === 'cxpd') {
        //审核通过才能重新派单，客户原因的可以直接派单
        if (params.data.REVIEW_TYPE === '1') {
          var editRow = params.data
          //TODO, 需要清空返，只保留服务单编号等信息
          Object.keys(editRow).map((key) => {
            if ('F_WORK_ORDER_ID,SERVICE_ORDER_ID,WORK_ORDER_CATEGORY'.indexOf(key) == -1) {
              delete editRow[key]
            }
          })
          editRow.IS_NEW = true
          editRow.SERVICE_STATE = '1' //待接单
          editRow.AFRESH_DISPATCH = 'true' //重新派单
          editRow.SERVICE_ORDER_ID_OLD = editRow.SERVICE_ORDER_ID
          if (params.data.WORK_ORDER_CATEGORY == '1') {
            this.baseComponent.smartLoadComponent('siteRequestForm', {
              serviceRequest: this,
              tableObj: this.tableObj,
              editRow: editRow,
              type: 'yw',
              title: '创建现场服务运维单',
              from: 'dispatchForm',
              requestId: 'backOrder',
            })
          } else {
            this.baseComponent.smartLoadComponent('siteRequestForm', {
              serviceRequest: this,
              tableObj: this.tableObj,
              editRow: editRow,
              type: 'gc',
              title: '创建现场服务工程单',
              from: 'dispatchForm',
              requestId: 'backOrder',
            })
          }
        }
        else {
          this.layer.openMsg('审核通过才能重新派单')
          return
        }
      }
      if (type === 'sp') {
        params.data.OPERATETYPE = type
        var componentName = 'backOrderSpform-' + params.data['SERVICE_ORDER_NUM']
        this.baseComponent.smartLoadComponent(
          'backOrderform',
          {
            title: '审批-' + params.data['SERVICE_ORDER_NUM'],
            source: 'workOrder',
            formData: params.data,
            operateType: type,
            tableObj: this.tableObj,
          },
          { uniqueName: componentName }
        )
      }
      if (type === 'ck') {
        var componentName = 'backOrderform-' + params.data['SERVICE_ORDER_NUM']
        this.baseComponent.smartLoadComponent(
          'backOrderform',
          {
            title: '详情-' + params.data['SERVICE_ORDER_NUM'],
            source: 'workOrder',
            formData: params.data,
            operateType: type,
          },
          { uniqueName: componentName }
        )
      }
    },
    renderRow(data) {
      if (data.AFRESH_DISPATCH_ID) {
        data.AFRESH_DISPATCH_ID_DESC = '是'
      } else {
        data.AFRESH_DISPATCH_ID_DESC = '否'
      }
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/workOrder/backOrde/index.vue